export default __webpack_public_path__ + "static/media/reportdropdown.13ec9ddd.svg";